import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/comparison')({
  component: ComparisonLayout,
})

export function ComparisonLayout() {
  return (
    <main className="relative z-10 w-full min-w-0 bg-background">
      <Outlet />
    </main>
  )
}
